import keyMirror from 'keymirror';
import { isSecure, setCookie } from '../../services/Helper';
import { COOKIES } from '../../services/Constants';

export const signInActionTypes = keyMirror({
	LOGIN_REQUEST: null,
	LOGIN_SUCCESS: null,
	LOGIN_ERROR: null,

	FIRST_VERIFY_REQUEST: null,
	FIRST_VERIFY_SUCCESS: null,
	FIRST_VERIFY_ERROR: null,

	SAVE_ACCESS_TOKEN: null,
	SET_SOCIAL_LOGIN_STATE: null,
	EXECUTE_CAPTCHA: null,

	HANDLE_STEPS_AFTER_LOGIN: null,

	EXECUTE_TFA: null,
	VERIFY_TFA_CODE_REQUEST: null,
	VERIFY_TFA_CODE_SUCCESS: null,
	VERIFY_TFA_CODE_ERROR: null,
});

export const PROVIDERS = {
	FACEBOOK: 'facebook',
	GOOGLE: 'google',
	APPLE: 'apple',
};

export const CLIENT_ID = '987857138378-93tunb79da2us83pnkbvv3s59vt5kjaa.apps.googleusercontent.com';

export const setDeviceTrustToken = (token, expiredAt) => {
	const expires = !isNaN(new Date(expiredAt).getTime())
		? new Date(expiredAt)
		: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);

	setCookie(COOKIES.deviceTrustToken, token, {
		expires,
		secure: isSecure(),
	});
};
